import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IScrollRestore {
  isHomeScrollRestore: boolean;
  isNotificationScrollRestore: boolean;
  isFollowerScrollRestore: boolean;
}

const initialState: IScrollRestore = {
  isHomeScrollRestore: true,
  isNotificationScrollRestore: true,
  isFollowerScrollRestore : true,
};

export const ScrollRestoreSlice = createSlice({
  name: "scroll_restore_slice",
  initialState,
  reducers: {
    setHomeScrollRestore: (state, action: PayloadAction<boolean>) => {
      state.isHomeScrollRestore = action.payload;
    },
    setNotificationScrollRestore: (state, action: PayloadAction<boolean>) => {
      state.isNotificationScrollRestore = action.payload;
    },
    setFollowerScrollRestore: (state, action: PayloadAction<boolean>) => {
      state.isFollowerScrollRestore = action.payload;
    },
  },
});

export const { setHomeScrollRestore, setNotificationScrollRestore , setFollowerScrollRestore } =
ScrollRestoreSlice.actions;

export default ScrollRestoreSlice.reducer;
